(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/app/assets/js/head.js":[function(require,module,exports){
'use strict';

// pick what tests you need from https://github.com/jnordberg/browsernizr/tree/master/test
require('browsernizr/test/touchevents');
require('browsernizr/test/video');
require('browsernizr/test/inputtypes');
require('browsernizr/test/css/flexbox');
require('browsernizr/test/css/flexboxtweener');

// make sure to do this _after_ importing the tests
require('browsernizr');

},{"browsernizr":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/index.js","browsernizr/test/css/flexbox":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/css/flexbox.js","browsernizr/test/css/flexboxtweener":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/css/flexboxtweener.js","browsernizr/test/inputtypes":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/inputtypes.js","browsernizr/test/touchevents":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/touchevents.js","browsernizr/test/video":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/video.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/index.js":[function(require,module,exports){
var Modernizr = require('./lib/Modernizr'),
    ModernizrProto = require('./lib/ModernizrProto'),
    classes = require('./lib/classes'),
    testRunner = require('./lib/testRunner'),
    setClasses = require('./lib/setClasses');

// Run each test
testRunner();

// Remove the "no-js" class if it exists
setClasses(classes);

delete ModernizrProto.addTest;
delete ModernizrProto.addAsyncTest;

// Run the things that are supposed to run after the tests
for (var i = 0; i < Modernizr._q.length; i++) {
  Modernizr._q[i]();
}

module.exports = Modernizr;

},{"./lib/Modernizr":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./lib/ModernizrProto":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js","./lib/classes":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/classes.js","./lib/setClasses":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/setClasses.js","./lib/testRunner":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testRunner.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js":[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
  // Fake some of Object.create so we can force non test results to be non "own" properties.
  var Modernizr = function() {};
  Modernizr.prototype = ModernizrProto;

  // Leak modernizr globally when you `require` it rather than force it here.
  // Overwrite name so constructor name is nicer :D
  Modernizr = new Modernizr();

  module.exports = Modernizr;


},{"./ModernizrProto.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js":[function(require,module,exports){
var tests = require('./tests.js');
  /**
   *
   * ModernizrProto is the constructor for Modernizr
   *
   * @class
   * @access public
   */

  var ModernizrProto = {
    // The current version, dummy
    _version: '3.3.1 (browsernizr 2.1.0)',

    // Any settings that don't work as separate modules
    // can go in here as configuration.
    _config: {
      'classPrefix': '',
      'enableClasses': true,
      'enableJSClass': true,
      'usePrefixes': true
    },

    // Queue of tests
    _q: [],

    // Stub these for people who are listening
    on: function(test, cb) {
      // I don't really think people should do this, but we can
      // safe guard it a bit.
      // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
      // This is in case people listen to synchronous tests. I would leave it out,
      // but the code to *disallow* sync tests in the real version of this
      // function is actually larger than this.
      var self = this;
      setTimeout(function() {
        cb(self[test]);
      }, 0);
    },

    addTest: function(name, fn, options) {
      tests.push({name: name, fn: fn, options: options});
    },

    addAsyncTest: function(fn) {
      tests.push({name: null, fn: fn});
    }
  };

  module.exports = ModernizrProto;


},{"./tests.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/tests.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/classes.js":[function(require,module,exports){

  var classes = [];
  module.exports = classes;


},{}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/contains.js":[function(require,module,exports){


  /**
   * contains checks to see if a string contains another string
   *
   * @access private
   * @function contains
   * @param {string} str - The string we want to check for substrings
   * @param {string} substr - The substring we want to search the first string for
   * @returns {boolean}
   */

  function contains(str, substr) {
    return !!~('' + str).indexOf(substr);
  }

  module.exports = contains;


},{}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/createElement.js":[function(require,module,exports){
var isSVG = require('./isSVG.js');
  /**
   * createElement is a convenience wrapper around document.createElement. Since we
   * use createElement all over the place, this allows for (slightly) smaller code
   * as well as abstracting away issues with creating elements in contexts other than
   * HTML documents (e.g. SVG documents).
   *
   * @access private
   * @function createElement
   * @returns {HTMLElement|SVGElement} An HTML or SVG element
   */

  function createElement() {
    if (typeof document.createElement !== 'function') {
      // This is the case in IE7, where the type of createElement is "object".
      // For this reason, we cannot call apply() as Object is not a Function.
      return document.createElement(arguments[0]);
    } else if (isSVG) {
      return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
    } else {
      return document.createElement.apply(document, arguments);
    }
  }

  module.exports = createElement;


},{"./isSVG.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/isSVG.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/cssToDOM.js":[function(require,module,exports){

  /**
   * cssToDOM takes a kebab-case string and converts it to camelCase
   * e.g. box-sizing -> boxSizing
   *
   * @access private
   * @function cssToDOM
   * @param {string} name - String name of kebab-case prop we want to convert
   * @returns {string} The camelCase version of the supplied name
   */

  function cssToDOM(name) {
    return name.replace(/([a-z])-([a-z])/g, function(str, m1, m2) {
      return m1 + m2.toUpperCase();
    }).replace(/^-/, '');
  }
  module.exports = cssToDOM;


},{}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/cssomPrefixes.js":[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var omPrefixes = require('./omPrefixes.js');
  var cssomPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : []);
  ModernizrProto._cssomPrefixes = cssomPrefixes;
  module.exports = cssomPrefixes;


},{"./ModernizrProto.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js","./omPrefixes.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/omPrefixes.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/docElement.js":[function(require,module,exports){

  /**
   * docElement is a convenience wrapper to grab the root element of the document
   *
   * @access private
   * @returns {HTMLElement|SVGElement} The root element of the document
   */

  var docElement = document.documentElement;
  module.exports = docElement;


},{}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/domPrefixes.js":[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var omPrefixes = require('./omPrefixes.js');
  /**
   * List of JavaScript DOM values used for tests
   *
   * @memberof Modernizr
   * @name Modernizr._domPrefixes
   * @optionName Modernizr._domPrefixes
   * @optionProp domPrefixes
   * @access public
   * @example
   *
   * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
   * than kebab-case properties, all properties are their Capitalized variant
   *
   * ```js
   * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
   * ```
   */

  var domPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : []);
  ModernizrProto._domPrefixes = domPrefixes;
  module.exports = domPrefixes;


},{"./ModernizrProto.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js","./omPrefixes.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/omPrefixes.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/domToCSS.js":[function(require,module,exports){

  /**
   * domToCSS takes a camelCase string and converts it to kebab-case
   * e.g. boxSizing -> box-sizing
   *
   * @access private
   * @function domToCSS
   * @param {string} name - String name of camelCase prop we want to convert
   * @returns {string} The kebab-case version of the supplied name
   */

  function domToCSS(name) {
    return name.replace(/([A-Z])/g, function(str, m1) {
      return '-' + m1.toLowerCase();
    }).replace(/^ms-/, '-ms-');
  }
  module.exports = domToCSS;


},{}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/fnBind.js":[function(require,module,exports){

  /**
   * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
   *
   * @access private
   * @function fnBind
   * @param {function} fn - a function you want to change `this` reference to
   * @param {object} that - the `this` you want to call the function with
   * @returns {function} The wrapped version of the supplied function
   */

  function fnBind(fn, that) {
    return function() {
      return fn.apply(that, arguments);
    };
  }

  module.exports = fnBind;


},{}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/getBody.js":[function(require,module,exports){
var createElement = require('./createElement.js');
var isSVG = require('./isSVG.js');
  /**
   * getBody returns the body of a document, or an element that can stand in for
   * the body if a real body does not exist
   *
   * @access private
   * @function getBody
   * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
   * artificially created element that stands in for the body
   */

  function getBody() {
    // After page load injecting a fake body doesn't work so check if body exists
    var body = document.body;

    if (!body) {
      // Can't use the real body create a fake one.
      body = createElement(isSVG ? 'svg' : 'body');
      body.fake = true;
    }

    return body;
  }

  module.exports = getBody;


},{"./createElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/createElement.js","./isSVG.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/isSVG.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/injectElementWithStyles.js":[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var docElement = require('./docElement.js');
var createElement = require('./createElement.js');
var getBody = require('./getBody.js');
  /**
   * injectElementWithStyles injects an element with style element and some CSS rules
   *
   * @access private
   * @function injectElementWithStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   */

  function injectElementWithStyles(rule, callback, nodes, testnames) {
    var mod = 'modernizr';
    var style;
    var ret;
    var node;
    var docOverflow;
    var div = createElement('div');
    var body = getBody();

    if (parseInt(nodes, 10)) {
      // In order not to give false positives we create a node for each test
      // This also allows the method to scale for unspecified uses
      while (nodes--) {
        node = createElement('div');
        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
        div.appendChild(node);
      }
    }

    style = createElement('style');
    style.type = 'text/css';
    style.id = 's' + mod;

    // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
    // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
    (!body.fake ? div : body).appendChild(style);
    body.appendChild(div);

    if (style.styleSheet) {
      style.styleSheet.cssText = rule;
    } else {
      style.appendChild(document.createTextNode(rule));
    }
    div.id = mod;

    if (body.fake) {
      //avoid crashing IE8, if background image is used
      body.style.background = '';
      //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
      body.style.overflow = 'hidden';
      docOverflow = docElement.style.overflow;
      docElement.style.overflow = 'hidden';
      docElement.appendChild(body);
    }

    ret = callback(div, rule);
    // If this is done after page load we don't want to remove the body so check if body exists
    if (body.fake) {
      body.parentNode.removeChild(body);
      docElement.style.overflow = docOverflow;
      // Trigger layout so kinetic scrolling isn't disabled in iOS6+
      docElement.offsetHeight;
    } else {
      div.parentNode.removeChild(div);
    }

    return !!ret;

  }

  module.exports = injectElementWithStyles;


},{"./ModernizrProto.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js","./createElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/createElement.js","./docElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/docElement.js","./getBody.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/getBody.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/inputElem.js":[function(require,module,exports){
var createElement = require('./createElement.js');
  /**
   * since we have a fairly large number of input tests that don't mutate the input
   * we create a single element that can be shared with all of those tests for a
   * minor perf boost
   *
   * @access private
   * @returns {HTMLInputElement}
   */
  var inputElem = createElement('input');
  module.exports = inputElem;


},{"./createElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/createElement.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/is.js":[function(require,module,exports){

  /**
   * is returns a boolean if the typeof an obj is exactly type.
   *
   * @access private
   * @function is
   * @param {*} obj - A thing we want to check the type of
   * @param {string} type - A string to compare the typeof against
   * @returns {boolean}
   */

  function is(obj, type) {
    return typeof obj === type;
  }
  module.exports = is;


},{}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/isSVG.js":[function(require,module,exports){
var docElement = require('./docElement.js');
  /**
   * A convenience helper to check if the document we are running in is an SVG document
   *
   * @access private
   * @returns {boolean}
   */

  var isSVG = docElement.nodeName.toLowerCase() === 'svg';
  module.exports = isSVG;


},{"./docElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/docElement.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/mStyle.js":[function(require,module,exports){
var Modernizr = require('./Modernizr.js');
var modElem = require('./modElem.js');
  var mStyle = {
    style: modElem.elem.style
  };

  // kill ref for gc, must happen before mod.elem is removed, so we unshift on to
  // the front of the queue.
  Modernizr._q.unshift(function() {
    delete mStyle.style;
  });

  module.exports = mStyle;


},{"./Modernizr.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./modElem.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/modElem.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/modElem.js":[function(require,module,exports){
var Modernizr = require('./Modernizr.js');
var createElement = require('./createElement.js');
  /**
   * Create our "modernizr" element that we do most feature tests on.
   *
   * @access private
   */

  var modElem = {
    elem: createElement('modernizr')
  };

  // Clean up this element
  Modernizr._q.push(function() {
    delete modElem.elem;
  });

  module.exports = modElem;


},{"./Modernizr.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./createElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/createElement.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/nativeTestProps.js":[function(require,module,exports){
var injectElementWithStyles = require('./injectElementWithStyles.js');
var domToCSS = require('./domToCSS.js');
  /**
   * nativeTestProps allows for us to use native feature detection functionality if available.
   * some prefixed form, or false, in the case of an unsupported rule
   *
   * @access private
   * @function nativeTestProps
   * @param {array} props - An array of property names
   * @param {string} value - A string representing the value we want to check via @supports
   * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
   */

  // Accepts a list of property names and a single value
  // Returns `undefined` if native detection not available
  function nativeTestProps(props, value) {
    var i = props.length;
    // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
    if ('CSS' in window && 'supports' in window.CSS) {
      // Try every prefixed variant of the property
      while (i--) {
        if (window.CSS.supports(domToCSS(props[i]), value)) {
          return true;
        }
      }
      return false;
    }
    // Otherwise fall back to at-rule (for Opera 12.x)
    else if ('CSSSupportsRule' in window) {
      // Build a condition string for every prefixed variant
      var conditionText = [];
      while (i--) {
        conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
      }
      conditionText = conditionText.join(' or ');
      return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function(node) {
        return getComputedStyle(node, null).position == 'absolute';
      });
    }
    return undefined;
  }
  module.exports = nativeTestProps;


},{"./domToCSS.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/domToCSS.js","./injectElementWithStyles.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/injectElementWithStyles.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/omPrefixes.js":[function(require,module,exports){

  /**
   * If the browsers follow the spec, then they would expose vendor-specific style as:
   *   elem.style.WebkitBorderRadius
   * instead of something like the following, which would be technically incorrect:
   *   elem.style.webkitBorderRadius

   * Webkit ghosts their properties in lowercase but Opera & Moz do not.
   * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
   *   erik.eae.net/archives/2008/03/10/21.48.10/

   * More here: github.com/Modernizr/Modernizr/issues/issue/21
   *
   * @access private
   * @returns {string} The string representing the vendor-specific style properties
   */

  var omPrefixes = 'Moz O ms Webkit';
  module.exports = omPrefixes;


},{}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/prefixes.js":[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
  /**
   * List of property values to set for css tests. See ticket #21
   * http://git.io/vUGl4
   *
   * @memberof Modernizr
   * @name Modernizr._prefixes
   * @optionName Modernizr._prefixes
   * @optionProp prefixes
   * @access public
   * @example
   *
   * Modernizr._prefixes is the internal list of prefixes that we test against
   * inside of things like [prefixed](#modernizr-prefixed) and [prefixedCSS](#-code-modernizr-prefixedcss). It is simply
   * an array of kebab-case vendor prefixes you can use within your code.
   *
   * Some common use cases include
   *
   * Generating all possible prefixed version of a CSS property
   * ```js
   * var rule = Modernizr._prefixes.join('transform: rotate(20deg); ');
   *
   * rule === 'transform: rotate(20deg); webkit-transform: rotate(20deg); moz-transform: rotate(20deg); o-transform: rotate(20deg); ms-transform: rotate(20deg);'
   * ```
   *
   * Generating all possible prefixed version of a CSS value
   * ```js
   * rule = 'display:' +  Modernizr._prefixes.join('flex; display:') + 'flex';
   *
   * rule === 'display:flex; display:-webkit-flex; display:-moz-flex; display:-o-flex; display:-ms-flex; display:flex'
   * ```
   */

  // we use ['',''] rather than an empty array in order to allow a pattern of .`join()`ing prefixes to test
  // values in feature detects to continue to work
  var prefixes = (ModernizrProto._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['','']);

  // expose these for the plugin API. Look in the source for how to join() them against your input
  ModernizrProto._prefixes = prefixes;

  module.exports = prefixes;


},{"./ModernizrProto.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/setClasses.js":[function(require,module,exports){
var Modernizr = require('./Modernizr.js');
var docElement = require('./docElement.js');
var isSVG = require('./isSVG.js');
  /**
   * setClasses takes an array of class names and adds them to the root element
   *
   * @access private
   * @function setClasses
   * @param {string[]} classes - Array of class names
   */

  // Pass in an and array of class names, e.g.:
  //  ['no-webp', 'borderradius', ...]
  function setClasses(classes) {
    var className = docElement.className;
    var classPrefix = Modernizr._config.classPrefix || '';

    if (isSVG) {
      className = className.baseVal;
    }

    // Change `no-js` to `js` (independently of the `enableClasses` option)
    // Handle classPrefix on this too
    if (Modernizr._config.enableJSClass) {
      var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
      className = className.replace(reJS, '$1' + classPrefix + 'js$2');
    }

    if (Modernizr._config.enableClasses) {
      // Add the new classes
      className += ' ' + classPrefix + classes.join(' ' + classPrefix);
      isSVG ? docElement.className.baseVal = className : docElement.className = className;
    }

  }

  module.exports = setClasses;


},{"./Modernizr.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./docElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/docElement.js","./isSVG.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/isSVG.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testAllProps.js":[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var testPropsAll = require('./testPropsAll.js');
  /**
   * testAllProps determines whether a given CSS property is supported in the browser
   *
   * @memberof Modernizr
   * @name Modernizr.testAllProps
   * @optionName Modernizr.testAllProps()
   * @optionProp testAllProps
   * @access public
   * @function testAllProps
   * @param {string} prop - String naming the property to test (either camelCase or kebab-case)
   * @param {string} [value] - String of the value to test
   * @param {boolean} [skipValueTest=false] - Whether to skip testing that the value is supported when using non-native detection
   * @example
   *
   * testAllProps determines whether a given CSS property, in some prefixed form,
   * is supported by the browser.
   *
   * ```js
   * testAllProps('boxSizing')  // true
   * ```
   *
   * It can optionally be given a CSS value in string form to test if a property
   * value is valid
   *
   * ```js
   * testAllProps('display', 'block') // true
   * testAllProps('display', 'penguin') // false
   * ```
   *
   * A boolean can be passed as a third parameter to skip the value check when
   * native detection (@supports) isn't available.
   *
   * ```js
   * testAllProps('shapeOutside', 'content-box', true);
   * ```
   */

  function testAllProps(prop, value, skipValueTest) {
    return testPropsAll(prop, undefined, undefined, value, skipValueTest);
  }
  ModernizrProto.testAllProps = testAllProps;
  module.exports = testAllProps;


},{"./ModernizrProto.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js","./testPropsAll.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testPropsAll.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testDOMProps.js":[function(require,module,exports){
var is = require('./is.js');
var fnBind = require('./fnBind.js');
  /**
   * testDOMProps is a generic DOM property test; if a browser supports
   *   a certain property, it won't return undefined for it.
   *
   * @access private
   * @function testDOMProps
   * @param {array.<string>} props - An array of properties to test for
   * @param {object} obj - An object or Element you want to use to test the parameters again
   * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
   */
  function testDOMProps(props, obj, elem) {
    var item;

    for (var i in props) {
      if (props[i] in obj) {

        // return the property name as a string
        if (elem === false) {
          return props[i];
        }

        item = obj[props[i]];

        // let's bind a function
        if (is(item, 'function')) {
          // bind to obj unless overriden
          return fnBind(item, elem || obj);
        }

        // return the unbound function or obj or value
        return item;
      }
    }
    return false;
  }

  module.exports = testDOMProps;


},{"./fnBind.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/fnBind.js","./is.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/is.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testProps.js":[function(require,module,exports){
var contains = require('./contains.js');
var mStyle = require('./mStyle.js');
var createElement = require('./createElement.js');
var nativeTestProps = require('./nativeTestProps.js');
var is = require('./is.js');
var cssToDOM = require('./cssToDOM.js');
  // testProps is a generic CSS / DOM property test.

  // In testing support for a given CSS property, it's legit to test:
  //    `elem.style[styleName] !== undefined`
  // If the property is supported it will return an empty string,
  // if unsupported it will return undefined.

  // We'll take advantage of this quick test and skip setting a style
  // on our modernizr element, but instead just testing undefined vs
  // empty string.

  // Property names can be provided in either camelCase or kebab-case.

  function testProps(props, prefixed, value, skipValueTest) {
    skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;

    // Try native detect first
    if (!is(value, 'undefined')) {
      var result = nativeTestProps(props, value);
      if (!is(result, 'undefined')) {
        return result;
      }
    }

    // Otherwise do it properly
    var afterInit, i, propsLength, prop, before;

    // If we don't have a style element, that means we're running async or after
    // the core tests, so we'll need to create our own elements to use

    // inside of an SVG element, in certain browsers, the `style` element is only
    // defined for valid tags. Therefore, if `modernizr` does not have one, we
    // fall back to a less used element and hope for the best.
    var elems = ['modernizr', 'tspan'];
    while (!mStyle.style) {
      afterInit = true;
      mStyle.modElem = createElement(elems.shift());
      mStyle.style = mStyle.modElem.style;
    }

    // Delete the objects if we created them.
    function cleanElems() {
      if (afterInit) {
        delete mStyle.style;
        delete mStyle.modElem;
      }
    }

    propsLength = props.length;
    for (i = 0; i < propsLength; i++) {
      prop = props[i];
      before = mStyle.style[prop];

      if (contains(prop, '-')) {
        prop = cssToDOM(prop);
      }

      if (mStyle.style[prop] !== undefined) {

        // If value to test has been passed in, do a set-and-check test.
        // 0 (integer) is a valid property value, so check that `value` isn't
        // undefined, rather than just checking it's truthy.
        if (!skipValueTest && !is(value, 'undefined')) {

          // Needs a try catch block because of old IE. This is slow, but will
          // be avoided in most cases because `skipValueTest` will be used.
          try {
            mStyle.style[prop] = value;
          } catch (e) {}

          // If the property value has changed, we assume the value used is
          // supported. If `value` is empty string, it'll fail here (because
          // it hasn't changed), which matches how browsers have implemented
          // CSS.supports()
          if (mStyle.style[prop] != before) {
            cleanElems();
            return prefixed == 'pfx' ? prop : true;
          }
        }
        // Otherwise just return true, or the property name if this is a
        // `prefixed()` call
        else {
          cleanElems();
          return prefixed == 'pfx' ? prop : true;
        }
      }
    }
    cleanElems();
    return false;
  }

  module.exports = testProps;


},{"./contains.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/contains.js","./createElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/createElement.js","./cssToDOM.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/cssToDOM.js","./is.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/is.js","./mStyle.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/mStyle.js","./nativeTestProps.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/nativeTestProps.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testPropsAll.js":[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var cssomPrefixes = require('./cssomPrefixes.js');
var is = require('./is.js');
var testProps = require('./testProps.js');
var domPrefixes = require('./domPrefixes.js');
var testDOMProps = require('./testDOMProps.js');
  /**
   * testPropsAll tests a list of DOM properties we want to check against.
   * We specify literally ALL possible (known and/or likely) properties on
   * the element including the non-vendor prefixed one, for forward-
   * compatibility.
   *
   * @access private
   * @function testPropsAll
   * @param {string} prop - A string of the property to test for
   * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
   * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
   * @param {string} [value] - A string of a css value
   * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
   */
  function testPropsAll(prop, prefixed, elem, value, skipValueTest) {

    var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
    props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

    // did they call .prefixed('boxSizing') or are we just testing a prop?
    if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
      return testProps(props, prefixed, value, skipValueTest);

      // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
    } else {
      props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
      return testDOMProps(props, prefixed, elem);
    }
  }

  // Modernizr.testAllProps() investigates whether a given style property,
  // or any of its vendor-prefixed variants, is recognized
  //
  // Note that the property names must be provided in the camelCase variant.
  // Modernizr.testAllProps('boxSizing')
  ModernizrProto.testAllProps = testPropsAll;

  module.exports = testPropsAll;


},{"./ModernizrProto.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js","./cssomPrefixes.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/cssomPrefixes.js","./domPrefixes.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/domPrefixes.js","./is.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/is.js","./testDOMProps.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testDOMProps.js","./testProps.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testProps.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testRunner.js":[function(require,module,exports){
var tests = require('./tests.js');
var Modernizr = require('./Modernizr.js');
var classes = require('./classes.js');
var is = require('./is.js');
  /**
   * Run through all tests and detect their support in the current UA.
   *
   * @access private
   */

  function testRunner() {
    var featureNames;
    var feature;
    var aliasIdx;
    var result;
    var nameIdx;
    var featureName;
    var featureNameSplit;

    for (var featureIdx in tests) {
      if (tests.hasOwnProperty(featureIdx)) {
        featureNames = [];
        feature = tests[featureIdx];
        // run the test, throw the return value into the Modernizr,
        // then based on that boolean, define an appropriate className
        // and push it into an array of classes we'll join later.
        //
        // If there is no name, it's an 'async' test that is run,
        // but not directly added to the object. That should
        // be done with a post-run addTest call.
        if (feature.name) {
          featureNames.push(feature.name.toLowerCase());

          if (feature.options && feature.options.aliases && feature.options.aliases.length) {
            // Add all the aliases into the names list
            for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
              featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
            }
          }
        }

        // Run the test, or use the raw value if it's not a function
        result = is(feature.fn, 'function') ? feature.fn() : feature.fn;


        // Set each of the names on the Modernizr object
        for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
          featureName = featureNames[nameIdx];
          // Support dot properties as sub tests. We don't do checking to make sure
          // that the implied parent tests have been added. You must call them in
          // order (either in the test, or make the parent test a dependency).
          //
          // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
          // hashtag famous last words
          featureNameSplit = featureName.split('.');

          if (featureNameSplit.length === 1) {
            Modernizr[featureNameSplit[0]] = result;
          } else {
            // cast to a Boolean, if not one already
            /* jshint -W053 */
            if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
              Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
            }

            Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
          }

          classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
        }
      }
    }
  }
  module.exports = testRunner;


},{"./Modernizr.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./classes.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/classes.js","./is.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/is.js","./tests.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/tests.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testStyles.js":[function(require,module,exports){
var ModernizrProto = require('./ModernizrProto.js');
var injectElementWithStyles = require('./injectElementWithStyles.js');
  /**
   * testStyles injects an element with style element and some CSS rules
   *
   * @memberof Modernizr
   * @name Modernizr.testStyles
   * @optionName Modernizr.testStyles()
   * @optionProp testStyles
   * @access public
   * @function testStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   * @example
   *
   * `Modernizr.testStyles` takes a CSS rule and injects it onto the current page
   * along with (possibly multiple) DOM elements. This lets you check for features
   * that can not be detected by simply checking the [IDL](https://developer.mozilla.org/en-US/docs/Mozilla/Developer_guide/Interface_development_guide/IDL_interface_rules).
   *
   * ```js
   * Modernizr.testStyles('#modernizr { width: 9px; color: papayawhip; }', function(elem, rule) {
   *   // elem is the first DOM node in the page (by default #modernizr)
   *   // rule is the first argument you supplied - the CSS rule in string form
   *
   *   addTest('widthworks', elem.style.width === '9px')
   * });
   * ```
   *
   * If your test requires multiple nodes, you can include a third argument
   * indicating how many additional div elements to include on the page. The
   * additional nodes are injected as children of the `elem` that is returned as
   * the first argument to the callback.
   *
   * ```js
   * Modernizr.testStyles('#modernizr {width: 1px}; #modernizr2 {width: 2px}', function(elem) {
   *   document.getElementById('modernizr').style.width === '1px'; // true
   *   document.getElementById('modernizr2').style.width === '2px'; // true
   *   elem.firstChild === document.getElementById('modernizr2'); // true
   * }, 1);
   * ```
   *
   * By default, all of the additional elements have an ID of `modernizr[n]`, where
   * `n` is its index (e.g. the first additional, second overall is `#modernizr2`,
   * the second additional is `#modernizr3`, etc.).
   * If you want to have more meaningful IDs for your function, you can provide
   * them as the fourth argument, as an array of strings
   *
   * ```js
   * Modernizr.testStyles('#foo {width: 10px}; #bar {height: 20px}', function(elem) {
   *   elem.firstChild === document.getElementById('foo'); // true
   *   elem.lastChild === document.getElementById('bar'); // true
   * }, 2, ['foo', 'bar']);
   * ```
   *
   */

  var testStyles = ModernizrProto.testStyles = injectElementWithStyles;
  module.exports = testStyles;


},{"./ModernizrProto.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/ModernizrProto.js","./injectElementWithStyles.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/injectElementWithStyles.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/tests.js":[function(require,module,exports){

  var tests = [];
  module.exports = tests;


},{}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/css/flexbox.js":[function(require,module,exports){
/*!
{
  "name": "Flexbox",
  "property": "flexbox",
  "caniuse": "flexbox",
  "tags": ["css"],
  "notes": [{
    "name": "The _new_ flexbox",
    "href": "http://dev.w3.org/csswg/css3-flexbox"
  }],
  "warnings": [
    "A `true` result for this detect does not imply that the `flex-wrap` property is supported; see the `flexwrap` detect."
  ]
}
!*/
/* DOC
Detects support for the Flexible Box Layout model, a.k.a. Flexbox, which allows easy manipulation of layout order and sizing within a container.
*/
var Modernizr = require('./../../lib/Modernizr.js');
var testAllProps = require('./../../lib/testAllProps.js');
  Modernizr.addTest('flexbox', testAllProps('flexBasis', '1px', true));


},{"./../../lib/Modernizr.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./../../lib/testAllProps.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testAllProps.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/css/flexboxtweener.js":[function(require,module,exports){
/*!
{
  "name": "Flexbox (tweener)",
  "property": "flexboxtweener",
  "tags": ["css"],
  "polyfills": ["flexie"],
  "notes": [{
    "name": "The _inbetween_ flexbox",
    "href": "https://www.w3.org/TR/2011/WD-css3-flexbox-20111129/"
  }],
  "warnings": ["This represents an old syntax, not the latest standard syntax."]
}
!*/
var Modernizr = require('./../../lib/Modernizr.js');
var testAllProps = require('./../../lib/testAllProps.js');
  Modernizr.addTest('flexboxtweener', testAllProps('flexAlign', 'end', true));


},{"./../../lib/Modernizr.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./../../lib/testAllProps.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testAllProps.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/inputtypes.js":[function(require,module,exports){
/*!
{
  "name": "Form input types",
  "property": "inputtypes",
  "caniuse": "forms",
  "tags": ["forms"],
  "authors": ["Mike Taylor"],
  "polyfills": [
    "jquerytools",
    "webshims",
    "h5f",
    "webforms2",
    "nwxforms",
    "fdslider",
    "html5slider",
    "galleryhtml5forms",
    "jscolor",
    "html5formshim",
    "selectedoptionsjs",
    "formvalidationjs"
  ]
}
!*/
/* DOC
Detects support for HTML5 form input types and exposes Boolean subproperties with the results:

```javascript
Modernizr.inputtypes.color
Modernizr.inputtypes.date
Modernizr.inputtypes.datetime
Modernizr.inputtypes['datetime-local']
Modernizr.inputtypes.email
Modernizr.inputtypes.month
Modernizr.inputtypes.number
Modernizr.inputtypes.range
Modernizr.inputtypes.search
Modernizr.inputtypes.tel
Modernizr.inputtypes.time
Modernizr.inputtypes.url
Modernizr.inputtypes.week
```
*/
var Modernizr = require('./../lib/Modernizr.js');
var inputElem = require('./../lib/inputElem.js');
var docElement = require('./../lib/docElement.js');
  // Run through HTML5's new input types to see if the UA understands any.
  //   This is put behind the tests runloop because it doesn't return a
  //   true/false like all the other tests; instead, it returns an object
  //   containing each input type with its corresponding true/false value

  // Big thanks to @miketaylr for the html5 forms expertise. miketaylr.com/
  var inputtypes = 'search tel url email datetime date month week time datetime-local number range color'.split(' ');
  var inputs = {};

  Modernizr.inputtypes = (function(props) {
    var len = props.length;
    var smile = '1)';
    var inputElemType;
    var defaultView;
    var bool;

    for (var i = 0; i < len; i++) {

      inputElem.setAttribute('type', inputElemType = props[i]);
      bool = inputElem.type !== 'text' && 'style' in inputElem;

      // We first check to see if the type we give it sticks..
      // If the type does, we feed it a textual value, which shouldn't be valid.
      // If the value doesn't stick, we know there's input sanitization which infers a custom UI
      if (bool) {

        inputElem.value         = smile;
        inputElem.style.cssText = 'position:absolute;visibility:hidden;';

        if (/^range$/.test(inputElemType) && inputElem.style.WebkitAppearance !== undefined) {

          docElement.appendChild(inputElem);
          defaultView = document.defaultView;

          // Safari 2-4 allows the smiley as a value, despite making a slider
          bool =  defaultView.getComputedStyle &&
            defaultView.getComputedStyle(inputElem, null).WebkitAppearance !== 'textfield' &&
            // Mobile android web browser has false positive, so must
            // check the height to see if the widget is actually there.
            (inputElem.offsetHeight !== 0);

          docElement.removeChild(inputElem);

        } else if (/^(search|tel)$/.test(inputElemType)) {
          // Spec doesn't define any special parsing or detectable UI
          //   behaviors so we pass these through as true

          // Interestingly, opera fails the earlier test, so it doesn't
          //  even make it here.

        } else if (/^(url|email)$/.test(inputElemType)) {
          // Real url and email support comes with prebaked validation.
          bool = inputElem.checkValidity && inputElem.checkValidity() === false;

        } else {
          // If the upgraded input compontent rejects the :) text, we got a winner
          bool = inputElem.value != smile;
        }
      }

      inputs[ props[i] ] = !!bool;
    }
    return inputs;
  })(inputtypes);


},{"./../lib/Modernizr.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./../lib/docElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/docElement.js","./../lib/inputElem.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/inputElem.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/touchevents.js":[function(require,module,exports){
/*!
{
  "name": "Touch Events",
  "property": "touchevents",
  "caniuse" : "touch",
  "tags": ["media", "attribute"],
  "notes": [{
    "name": "Touch Events spec",
    "href": "https://www.w3.org/TR/2013/WD-touch-events-20130124/"
  }],
  "warnings": [
    "Indicates if the browser supports the Touch Events spec, and does not necessarily reflect a touchscreen device"
  ],
  "knownBugs": [
    "False-positive on some configurations of Nokia N900",
    "False-positive on some BlackBerry 6.0 builds – https://github.com/Modernizr/Modernizr/issues/372#issuecomment-3112695"
  ]
}
!*/
/* DOC
Indicates if the browser supports the W3C Touch Events API.

This *does not* necessarily reflect a touchscreen device:

* Older touchscreen devices only emulate mouse events
* Modern IE touch devices implement the Pointer Events API instead: use `Modernizr.pointerevents` to detect support for that
* Some browsers & OS setups may enable touch APIs when no touchscreen is connected
* Future browsers may implement other event models for touch interactions

See this article: [You Can't Detect A Touchscreen](http://www.stucox.com/blog/you-cant-detect-a-touchscreen/).

It's recommended to bind both mouse and touch/pointer events simultaneously – see [this HTML5 Rocks tutorial](http://www.html5rocks.com/en/mobile/touchandmouse/).

This test will also return `true` for Firefox 4 Multitouch support.
*/
var Modernizr = require('./../lib/Modernizr.js');
var prefixes = require('./../lib/prefixes.js');
var testStyles = require('./../lib/testStyles.js');
  // Chrome (desktop) used to lie about its support on this, but that has since been rectified: http://crbug.com/36415
  Modernizr.addTest('touchevents', function() {
    var bool;
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      bool = true;
    } else {
      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      var query = ['@media (', prefixes.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join('');
      testStyles(query, function(node) {
        bool = node.offsetTop === 9;
      });
    }
    return bool;
  });


},{"./../lib/Modernizr.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./../lib/prefixes.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/prefixes.js","./../lib/testStyles.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/testStyles.js"}],"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/test/video.js":[function(require,module,exports){
/*!
{
  "name": "HTML5 Video",
  "property": "video",
  "caniuse": "video",
  "tags": ["html5"],
  "knownBugs": [
    "Without QuickTime, `Modernizr.video.h264` will be `undefined`; https://github.com/Modernizr/Modernizr/issues/546"
  ],
  "polyfills": [
    "html5media",
    "mediaelementjs",
    "sublimevideo",
    "videojs",
    "leanbackplayer",
    "videoforeverybody"
  ]
}
!*/
/* DOC
Detects support for the video element, as well as testing what types of content it supports.

Subproperties are provided to describe support for `ogg`, `h264` and `webm` formats, e.g.:

```javascript
Modernizr.video         // true
Modernizr.video.ogg     // 'probably'
```
*/
var Modernizr = require('./../lib/Modernizr.js');
var createElement = require('./../lib/createElement.js');
  // Codec values from : github.com/NielsLeenheer/html5test/blob/9106a8/index.html#L845
  //                     thx to NielsLeenheer and zcorpan

  // Note: in some older browsers, "no" was a return value instead of empty string.
  //   It was live in FF3.5.0 and 3.5.1, but fixed in 3.5.2
  //   It was also live in Safari 4.0.0 - 4.0.4, but fixed in 4.0.5

  Modernizr.addTest('video', function() {
    /* jshint -W053 */
    var elem = createElement('video');
    var bool = false;

    // IE9 Running on Windows Server SKU can cause an exception to be thrown, bug #224
    try {
      if (bool = !!elem.canPlayType) {
        bool = new Boolean(bool);
        bool.ogg = elem.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, '');

        // Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
        bool.h264 = elem.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '');

        bool.webm = elem.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, '');

        bool.vp9 = elem.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, '');

        bool.hls = elem.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, '');
      }
    } catch (e) {}

    return bool;
  });


},{"./../lib/Modernizr.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/Modernizr.js","./../lib/createElement.js":"/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/node_modules/browsernizr/lib/createElement.js"}]},{},["/Users/msadler/Desktop/local-repositories/booth-gleacher-center/src/dev/app/assets/js/head.js"]);
